import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { FormInput } from "../FormInput";
import { useLazyQuery } from "@apollo/client";
import { SEARCHBYSCHOOL } from "../../graphql/queries";
import { SelectableList } from "../SelectableList";

export const SearchSchoolComponent = ({
  addSelectedOrganization,
  showNewOrgForm,
  isAdding,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [orgList, setOrgList] = useState([]);
  const [typingTimer, setTypingTimer] = useState(null);

  const [searchSchool] = useLazyQuery(SEARCHBYSCHOOL, {
    onCompleted: (data) => {
      if (data.searchBySchool.length > 0) {
        setOrgList(data.searchBySchool);
      }
    },
    onError: (e) => {
      console.log({ e });
    },
    fetchPolicy: "cache-and-network",
  });

  const handleChange = (e) => {
    clearTimeout(typingTimer); // Clear the previous timer

    const query = e.target.value.trim();
    setSearchQuery(query);

    // If the input field is empty, don't trigger the search
    if (query === "") {
      setOrgList([]);
      return;
    }

    // Set a new timer
    setTypingTimer(
      setTimeout(() => {
        searchSchool({
          variables: {
            name: query,
            limit: 5,
          },
        });
      }, 500)
    );
  };

  return (
    <Box
      style={{
        padding: "10px 20px",
      }}
    >
      <FormInput
        name="name"
        label="Your school or organization name"
        isLabelCapitalized={false}
        placeholder="Search..."
        value={searchQuery}
        inputOnChange={handleChange}
        type="text"
        formProps={{ required: true, padding: "0" }}
      />
      <SelectableList
        items={orgList.map((org) => ({ ...org, name: org.schoolName }))}
        onAdd={(id) =>
          addSelectedOrganization(orgList.find((org) => org.id === id))
        }
        isAdding={isAdding}
        showNewOrgForm={showNewOrgForm}
      />
    </Box>
  );
};
